import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, timer, Subscription } from 'rxjs';
import { ScreeningReport } from '../models/screening-report.model';
import { SurveyService } from '../services/survey.service';
import { LocalstorageService } from '../services/localstorage.service';
import { QuestionTranformationService } from '../services/question-tranformation.service';

const EXPIRYTHRESHHOLD = 43200; //12 hours
const EXPOSUREEXPIRYTHRESHHOLD = 10; //10 seconds

@Component({
  selector: 'app-screening-report',
  templateUrl: './screening-report.component.html',
  styleUrls: ['./screening-report.component.css']
})
export class ScreeningReportComponent implements OnInit, OnDestroy {
  timeLeft: number = 10;
  private subscription: Subscription;
  private subscription2: Subscription;

  screeningReportModel: ScreeningReport;
  newScreeningReport: string = null;
  event: string;
  currentEvent: string = '';
  currentEventDisplayName: string = '';

  exposureRedirectCountdown: number = EXPOSUREEXPIRYTHRESHHOLD;
  //location: string;


  unvaccinatedCompliant = false;
  unvaccinatedNotCompliant = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    public surveyService: SurveyService,
    private localstorageService: LocalstorageService,    
    private tranformationService: QuestionTranformationService){}
 
  async ngOnInit() {
    // this.event = this.surveyService.locationOrEvent.event;
    // this.location = this.surveyService.locationOrEvent.location;
    // console.log("event:" + this.event + ' location: ' + this.location);
    this.newScreeningReport = this.localstorageService.getItem("newScreeningReport");
    console.log("New Screening Report: ", this.newScreeningReport);
    console.log('ngOnInit: ', this.newScreeningReport);
    this.currentEvent = this.surveyService.locationOrEvent.event;
    console.log('Current Event', this.currentEvent);

    this.screeningReportModel = new ScreeningReport();
    let authDetails = this.localstorageService.getAuth();
    
    (await this.surveyService.getEventDisplayName(authDetails.employeeInfo.corpId)).toPromise().then(response =>{
      this.event = response.displayName;
    });

    await this.tranformationService.loadDynamicQuestionTexts(authDetails.employeeInfo.corpId);

    this.surveyService.getScreeningReport(authDetails.employeeInfo.corpId).subscribe(responseData => {
      console.log('Screening Model: ', responseData);

      if (responseData.message === null) {
        this.startNewScreening();
      }
      
      this.screeningReportModel = responseData;
      //replace mask message key
      this.screeningReportModel.message = this.tranformationService.replaceMaskMessage(this.screeningReportModel.message);
      this.timeLeft = Math.floor(this.screeningReportModel.timeLeft);

      this.localstorageService.setItem("screeningReport",this.timeLeft,this.timeLeft);      
      this.localstorageService.removeItem("newScreeningReport");
      if(this.timeLeft <= 1){
        this.localstorageService.removeItem("screeningReport");
        this.router.navigateByUrl('/screening/pre-shift');
      }

      this.oberserableTimer();

      if (this.screeningReportModel.resultType == 'Fail' && this.surveyService.showRedirectTimer && this.screeningReportModel.message.indexOf('covid-exposure') > 0)
        this.observableTimerExposureRedirect();

      this.surveyService.getComplianceStatus(authDetails.employeeInfo.corpId).subscribe(({unvaccinatedCompliant, unvaccinatedNotCompliant})=>{
        this.unvaccinatedCompliant = unvaccinatedCompliant;
        this.unvaccinatedNotCompliant = unvaccinatedNotCompliant;
      })
    }, error=> console.log(error));
    
  }

  ngOnDestroy(): void {
    if(this.subscription != null)
      this.subscription.unsubscribe();

    if (this.subscription2 != null)
      this.subscription2.unsubscribe();
  }

  startNewScreening(){
    this.localstorageService.setItem("newScreeningReport",1);

    this.localstorageService.removeItem("screeningReport");
    this.router.navigateByUrl('/screening/pre-shift');
  }

  oberserableTimer() {
    const source = timer(1, 1000);
    this.subscription = source.subscribe(val => {

      let now = new Date().getTime();
      this.timeLeft = EXPIRYTHRESHHOLD - (now - (new Date(this.screeningReportModel.enteredDateTime).getTime()))/1000;

      let totalTimeLeft = Math.floor(this.timeLeft);
      
      this.screeningReportModel.secondsDisplay = this.getSeconds(totalTimeLeft);
      this.screeningReportModel.minutesDisplay = this.getMinutes(totalTimeLeft);
      this.screeningReportModel.hoursDisplay = this.getHours(totalTimeLeft);
      //console.log(this.timeLeft, totalTimeLeft, val);

      if(totalTimeLeft <= 0){
        this.router.navigate(['/screening/pre-shift']);
      }

      // let now = new Date().getTime();
      // let clientSidePassedTime = (now - (new Date(this.screeningReportModel.enteredDateTime).getTime()))/1000; //time in second
      // let passedTime = (EXPIRYTHRESHHOLD - totalTimeLeft);
      // console.log(passedTime, clientSidePassedTime);
      // if(passedTime > clientSidePassedTime - 100){ //total time left is greater than 100s difference
      //   setTimeout(() => {
      //     window.location.reload(true);
      //   }, 100);
      // }

    });
  }

  observableTimerExposureRedirect() {
    const source = timer(1, 1000);
    this.subscription2 = source.subscribe(val => {
      this.exposureRedirectCountdown = EXPOSUREEXPIRYTHRESHHOLD - val;

      if (val == EXPOSUREEXPIRYTHRESHHOLD) {
        this.surveyService.showRedirectTimer = false;
        this.router.navigate(['/covid-exposure'])
      }
    })
  }

  private getSeconds(ticks:number){
    return this.pad(ticks % 60);
  }

  private getMinutes(ticks:number){
    return this.pad((Math.floor(ticks / 60)) % 60);
  }

  private getHours(ticks:number){
    return this.pad(Math.floor((ticks / 60) / 60));
  }

  private pad(digit: any){
    return digit <= 9 ? '0' + digit : digit;
  }
}
